import * as React from 'react'
import './index.less'
import {URL_YUQUE_FEATURES} from "../../constants/CyHomepage";

const links: {
  link: string,
  title: string | React.ReactNode,
  needLogin?: boolean,
  outerLink?: true
  isOpenNewWindow?: boolean
  isNew?: boolean
}[] = [
  {
    link: '/',
    title: '首页',
    outerLink: true,
    isOpenNewWindow: false
  },
  {
    link: '/practice',
    title: '体验',
    outerLink: true,
    isOpenNewWindow: false
  },
  {
    link: URL_YUQUE_FEATURES,
    title: '功能介绍',
    outerLink: true,
    isOpenNewWindow: true
  },
  {
    link: '/static/help/',
    title: '帮助文档',
    outerLink: true,
    isOpenNewWindow: true
  },
  {
    link: '/partner',
    title: '合作伙伴',
    outerLink: true,
    isOpenNewWindow: true
  },
  {
    link: 'https://m.kuaizhan.com/clubpc/forums/VIk9iSUgWjLKn1do#!/topics/tags/WBgw4K6mfilDzBdu/pages/0',
    title: '站长社区',
    outerLink: true,
    isOpenNewWindow: true
  },
]

const DrawerLinks: React.FC<{
  navLinks?: Array<{
    link: string,
    title: string,
    outerLink?: boolean
    isOpenNewWindow?: boolean
    isNew?: boolean
    category: string
    page: string
  }>,
  currentLink?: string,
  className?: string
}> = ({
        navLinks = links,
        currentLink = '',
        className = ''
      }) => {

  function clickStat(category, page) {
    // 统计导航内容点击流量
    if (window) {
      // 用 stat-portrait
      // @ts-ignore
      window.xqui.useStat({
        action: 'click',
        category: category,
        bizType: 5,
        page: page
      })
    }
  }

  return (
        // @ts-ignore
        (navLinks && navLinks.length) ? navLinks.map(item => {
          return (
              <a className={className}
                 href={item.link}
                 onClick={() => clickStat(item.category, item.page)}>{item.title}</a>
          )
        }) : ''
  )
}

export default DrawerLinks
